import React, { useContext, useState } from 'react';
import './styles.less';
// import { CreateSearchAlert } from 'shared-components/Components/SearchAlert/CreateSearchAlert/web';
import { useFilters } from 'shared-components/Components/Filters/Filters.hook';
import { useSearchResultsFilters } from '../Filters/SearchResultsFilters.hook';
import { useActiveFiltersTags } from '../ActiveFiltersTags/ActiveFiltersTags.hook';
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context';
import {
	operation_type_id,
} from './options';
import { BedroomsAndBathrooms } from './BedroomsAndBathrooms/web';
import { RangePriceFilter } from './RangePrice/web';
import { LocationTagHolder } from 'shared-components/Components/Filters/KeywordLocation/LocationTagsHolder';
import SiderBar from 'RefactorSearchPage/SiderBar';
import { FiltersIcon } from 'shared-components/Components/CustomIcons/FiltersIcon/web';
import { AmenitiesFilter } from './AmenitiesFilter/web';
import { PropertyTypeFilter } from './PropertyType/web';
import { OperationTypeFilter } from './OperationType/web';
import { DataOptionsTypes } from './types';
import { SeasonAndDatesFilter } from './SeasonAndDatesFilter/web';
import { DrawingOnMapTag } from './DrawingOnMapTag/web';
import { RangeSurface } from './RangeSurface/web';
import { SlidersHorizontal } from 'shared-components/Components/CustomIcons/SlidersHorizontal/web';

const TopBarFilters = () => {
	const { filters, filtersTags, showFilter} = useFilters()
	const { changeFiltersAndUpdateURL, updateURL } = useSearchResultsFilters()
	const { country_code } = useContext(ConfigStateContext);
	const { filtersTagsToShow } = useActiveFiltersTags();

	const [filterVisible, setFilterVisible] = useState<boolean>(false)
	const appliedFilters = [...new Set(filtersTagsToShow?.filter(e => e.deleteable)?.map(e => e.key))].length
	const operationTypeIdList: DataOptionsTypes[] = operation_type_id.filter((p) => p.countries.includes(country_code ? country_code.toUpperCase() : ""))

	const handleCleanFilters = () => {
		const restoredValues = filtersTagsToShow.filter((item) => item.deleteable).reduce((acc, item) => {
			let valueToRestore;

			if (item.key === "property_type_id" ||
			item.key === "bedrooms" ||
			item.key === "bathrooms" ||
			item.key === "constStatesID" ||
			item.key === "neighborhood_id" ||
			item.key === "facilitiesGroup"
			) valueToRestore = {[item.key]: []};
			else valueToRestore = item.onChangeObject;

			return { ...acc, ...valueToRestore };
		}, {});

		changeFiltersAndUpdateURL(restoredValues)
    	// setRangeDate(null)
  	}

  	return (
		<div className="topBarFilters">
			<div className="topBarFilters__container">
				{/* Filtro ubicación */}
				<div className="topBarFilters__searchKeyword">
					<LocationTagHolder
						changeFilters={changeFiltersAndUpdateURL}
						filtersTags={filtersTags}
						show={showFilter.location}
					/>
				</div>

				{/* Filtro de Tipo de Operación */}
				<OperationTypeFilter
					show={showFilter.operationType && operationTypeIdList && operationTypeIdList.length}
				/>

				{/* Filtro de Búsqueda por temporadas o fechas en Casas en el Este */}
				<SeasonAndDatesFilter show={showFilter.temporal} />

				{/* Filtro de Tipo de Propiedad */}
				<PropertyTypeFilter show={showFilter.propertyType} />

				{/* Filtro de Rango de Precios */}
				<RangePriceFilter show={showFilter.price} />

				{/* Filtro de Rango de metraje */}
				<RangeSurface
					show={
						(filters?.property_type_id && [3, 12].some(e => filters?.property_type_id.includes(e)))
					}
				/>

				{/* Filtro de Cantidad de Dormitorios y baños */}
				<BedroomsAndBathrooms show={showFilter.bedroom || showFilter.bathrooms || showFilter.rooms} />

				{/* Filtro de amenities */}
				<AmenitiesFilter
					changeFilters={changeFiltersAndUpdateURL}
					filters={filters} filtersTags={filtersTags}
					show={showFilter.amenities}
				/>

				{/* Tag de Dibujo en mapa */}
				<DrawingOnMapTag show={showFilter.mapPolygon} />
				
				{/* Otros filtros */}
				<div className="inputFilterBox">
					<div
						className={`inputFilterBox__label`}
						onClick={() => {setFilterVisible(true)}}
					>
						<SlidersHorizontal width={16} />
						<p>Más filtros</p>

						{appliedFilters > 0 ?
							<div className="inputFilterBox__label--count">
								<span>{appliedFilters}</span>
							</div>
							: null
						}
					</div>
				</div>

				{filterVisible &&
					<SiderBar
						changeFilters={changeFiltersAndUpdateURL}
						filtersTags={filtersTags}
						updateURL={updateURL}
						filters={filters}
						useModal={true}
						updateUrlOnRealTime={true}
						sider={filterVisible}
						setSider={()=>{setFilterVisible(false)}}
						cleanFilters={handleCleanFilters}
						showFilter={showFilter}
					/>
				}

				{/* Temporary hidden */}
				{/* <div className="topBarFilters__createAlert">
					<CreateSearchAlert />
				</div> */} 
			</div>
		</div>
  	);
}

export default TopBarFilters
